// Module
var code = "<div fg-property-field-common=\"{ fieldname: true, displayname: true, placeholder: false, tooltip: false }\"></div> <div class=\"properties-validation\"> <div fg-property-field-validation=\"{ required: true}\"></div> </div> ";
// Exports
export default code;